import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m19 5 3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 22 3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M7.5 13.5 10 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10.5 16.5 13 14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Unplug";
const Unplug = memo(themed(Icon));
export {
  Unplug
};
//# sourceMappingURL=unplug.js.map
